import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthorPage() {
  const { slug } = useParams();
  const [author, setAuthor] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setAuthor(null); setError(false);
    api.get(`/authors/${slug}`)
      .then(r => setAuthor(r.data))
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-16 text-slate-500">
        Author not found. <Link to="/" className="text-sky-700 hover:text-sky-900">Return home →</Link>
      </div>
    );
  }
  if (!author) return <div className="max-w-3xl mx-auto px-6 py-16 text-slate-400">Loading…</div>;

  return (
    <div data-testid="author-page" className="max-w-3xl mx-auto px-6 md:px-10 py-16">
      <div className="text-xs font-bold uppercase tracking-[0.24em] text-sky-700 mb-3">Author</div>
      <h1 data-testid="author-name" className="font-heading text-4xl md:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]">
        {author.name}
      </h1>
      {author.title && <div className="mt-3 text-slate-500 text-sm">{author.title}</div>}
      {author.bio && <p className="mt-5 text-slate-700 leading-relaxed max-w-2xl">{author.bio}</p>}

      <div className="mt-14 pt-8 border-t border-slate-200">
        <div className="text-xs font-bold uppercase tracking-[0.24em] text-slate-500 mb-4">
          Posts by {author.name} <span className="text-slate-400 normal-case">· {author.blogs?.length || 0}</span>
        </div>
        {(!author.blogs || author.blogs.length === 0) ? (
          <p className="text-slate-500 italic">No posts published yet.</p>
        ) : (
          <ul className="divide-y divide-slate-200">
            {author.blogs.map(b => (
              <li key={b.blog_id} className="py-5">
                <Link
                  data-testid={`author-post-${b.blog_id}`}
                  to={`/blogs/${b.slug}`}
                  className="group block"
                >
                  <div className="font-heading text-xl font-semibold text-slate-900 group-hover:text-sky-700 transition-colors">
                    {b.title}
                  </div>
                  {b.excerpt && <p className="mt-1 text-slate-600 leading-relaxed line-clamp-2">{b.excerpt}</p>}
                  <div className="mt-2 text-xs text-slate-400">
                    {b.release_date && <>Published {new Date(b.release_date).toLocaleDateString()} · </>}
                    {b.view_count || 0} views
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
